module.exports = __webpack_public_path__ + "static/media/relocate_gateway.149333c6.png";